import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Houzzdat_logo.jpg';

const Footer = () => (
  <footer className="bg-background border-t border-gray-200 py-6 mt-8 text-center text-primary">
    <div className="flex flex-col md:flex-row items-center justify-between max-w-5xl mx-auto px-4 gap-2">
      <div className="text-left">
        <span className="font-semibold">Houzzdat</span> &copy; {new Date().getFullYear()}<br />
        <span className="text-sm block">For inquiries: <a href="mailto:info@houzzdat.com" className="text-accent hover:underline">info@houzzdat.com</a></span>
        <span className="text-sm block">74, I Infra Hibiscus</span>
        <span className="text-sm block">3rd Main, Indira nagar</span>
        <span className="text-sm block">Bangalore, Karnataka - 560038</span>
      </div>
      <div>
        <a href="https://wa.me/917996005799" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 bg-accent text-white rounded-xl shadow-soft font-semibold hover:bg-primary transition">
          WhatsApp
        </a>
      </div>
      <div className="flex flex-col items-end text-xs text-gray-500">
        <span>Built for real estate developers</span>
        <span className="text-sm block mt-2">
          <a href="#terms" className="text-accent hover:underline">Terms &amp; Conditions</a>
        </span>
        <span className="text-sm block mt-2">
          <a href="#faqs" className="text-accent hover:underline">FAQs</a>
        </span>
        <span className="text-sm block mt-2">
          <a href="#products" className="text-accent hover:underline">Products</a>
        </span>
        <span className="text-sm block mt-2">
          <a href="#brands" className="text-accent hover:underline">Brands</a>
        </span>
      </div>
    </div>
    {/* Placeholder for Terms & Conditions modal or page */}
  </footer>
);

export default Footer; 